export default {
    variants: {
        navLocaleMenu: {
            content: {
                width: 'xs',
                minWidth: '240px',
                border: '1px solid transparent',
                borderColor: 'transparent',
                borderRadius: 'base',
                boxShadow: '0px 1px 12px rgba(0, 0, 0, 0.25)'
            }
        },
        footerLocaleMenu: {
            content: {
                width: '100px',
                minWidth: '100px',
                border: '1px solid transparent',
                borderColor: 'transparent',
                borderRadius: 'base',
                boxShadow: '0px 1px 12px rgba(0, 0, 0, 0.25)',
                bg: 'lightBeige',
                padding: '0 16px'
            }
        }
    }
}
